  <div class="p-grid p-justify-around p-ai-center dum-footer ">
    <div class="p-md-2">
      <img class="img-fluid" [src]="imgDuminvalFooter"/>
    </div>
    <div class="p-md-2 p-d-flex p-flex-column p-jc-center">
      <p>
        <a class="p-mr-3" href="https://www.valladolid.es/en/indice-rss">
          <span class="fa fa-rss-square fa-3x"></span>
        </a>
        <a class="p-mr-3" href="https://www.youtube.com/user/ValladolidAyto">
          <i class="fab fa-youtube-square fa-3x"></i>
        </a>
        <a class="p-mr-3" href="https://twitter.com/AyuntamientoVLL">
          <i class="fab fa-twitter-square fa-3x"></i>
        </a>
        <a class="p-mr-3" href="http://www.facebook.com/AyuntamientodeValladolid">
          <i class="fab fa-facebook-square fa-3x"></i>
        </a>
        <a class="p-mr-3" href="https://www.instagram.com/AyuntamientoVLL">
          <i class="fab fa-instagram-square fa-3x"></i>
        </a>
      </p>
      <p>
        {{'GLOBAL.FOOTER.DIRECCION1' | translate}}
        <br />
        {{'GLOBAL.FOOTER.DIRECCION2' | translate}}
        <br />
        {{'GLOBAL.FOOTER.TELEFONO' | translate}}
      </p>
    </div>
    <div class="p-md-2 p-d-flex p-flex-column p-jc-center p-ai-center">
      <p class="w-75 text-center">
        {{'GLOBAL.TEXTO.FOOTER' |translate}}
      </p>
    </div>
    <div class="p-md-2 p-d-flex p-jc-center p-flex-column">
    <p-menu [model]="items"></p-menu>
    <div><a href="aviso-legal">Aviso legal</a></div>
    <div><a href="politica-privacidad">Política de privacidad</a></div>
    <div><a href="politica-cookies">Política de cookies</a></div>
    </div>
  </div>

